module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "pt2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PN"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_43",
      "title": "43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#p_pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Zarnika")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-No-Indent-potx1"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("DESCRIPTION:")]), _vm._v(" Naturally occurring mineral, brittle and gray, often with a colorless, odorless crystalline coating, soluble in water. Poisonous to ingest directly or through plants or water supplies in high concentration areas. Poison can also be absorbed through skin.")]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("SYMPTOMS:")]), _vm._v(" Facial swelling, acute abdominal pain, vomiting, diarrhea, leading into coma and death.")]), _vm._v(" "), _c('p', {
    staticClass: "Part-Opening-Text-potx"
  }, [_c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("PROOFING CUES:")]), _vm._v(" Subtle, sweet, and slightly metallic flavor, difficult to detect at low levels or in sweet dishes.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72536a24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part2.vue
// module id = 81
// module chunks = 0